import React, { useEffect, useRef } from 'react';
import videojs from 'video.js';
// import './video-js.scss';
import 'video.js/dist/video-js.min.css';

// function VideoPlayer(props) {
function VideoPlayer({
  options,
  onReady,
}) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  /* const {
    options,
    onReady,
    isPaused,
  } = props; */

  useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
    // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement('video-js');

      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);

      playerRef.current = videojs(videoElement, options, () => {
        videojs.log('player is ready');
        if (onReady) onReady(playerRef.current);
      });

      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;
      player.src(options.sources);
      player.autoplay(!options.isPaused);
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
}

export default VideoPlayer;
